var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraftAdvice3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08081 7.25282H1.08081C1.08081 5.31976 2.64743 3.75293 4.58092 3.75293C6.5144 3.75293 8.08081 5.31955 8.08081 7.25282Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11729 1.88808C6.11729 2.73607 5.43017 3.75437 4.58218 3.75437C4.35201 3.75437 4.13445 3.67877 3.93894 3.55256C3.77147 3.44458 3.62427 3.30804 3.50403 3.14915L3.49458 3.1397C3.21401 2.78017 3.0437 2.31355 3.0437 1.88808C3.0437 1.48006 3.20579 1.08874 3.49431 0.800219C3.78283 0.511698 4.17415 0.349609 4.58218 0.349609C5.43017 0.349609 6.11729 1.0401 6.11729 1.88808Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6809 7.25282H12.6809C12.6809 5.31976 14.2475 3.75293 16.181 3.75293C18.1145 3.75293 19.6809 5.31955 19.6809 7.25282Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7174 1.88808C17.7174 2.73607 17.0303 3.75437 16.1823 3.75437C15.9521 3.75437 15.7345 3.67877 15.539 3.55256C15.3716 3.44458 15.2244 3.30804 15.1041 3.14915L15.0947 3.1397C14.8141 2.78017 14.6438 2.31355 14.6438 1.88808C14.6438 1.48006 14.8059 1.08874 15.0944 0.800219C15.3829 0.511698 15.7742 0.349609 16.1823 0.349609C17.0303 0.349609 17.7174 1.0401 17.7174 1.88808Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0808 7.25282H24.0808C24.0808 5.31976 25.6474 3.75293 27.5809 3.75293C29.5144 3.75293 31.0808 5.31955 31.0808 7.25282Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1173 1.88808C29.1173 2.73607 28.4302 3.75437 27.5822 3.75437C27.352 3.75437 27.1345 3.67877 26.9389 3.55256C26.7715 3.44458 26.6243 3.30804 26.504 3.14915L26.4946 3.1397C26.214 2.78017 26.0437 2.31355 26.0437 1.88808C26.0437 1.48006 26.2058 1.08874 26.4943 0.800219C26.7828 0.511698 27.1741 0.349609 27.5822 0.349609C28.4302 0.349609 29.1173 1.0401 29.1173 1.88808Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 10.5449,
    width: 8.2207,
    height: 8.2207,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5518,
    y: 10.5449,
    width: 8.2207,
    height: 8.2207,
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0259,
    y: 10.5449,
    width: 8.2207,
    height: 8.2207,
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7068 25.7032C32.9021 25.5079 32.9021 25.1913 32.7068 24.9961L29.5248 21.8141C29.3296 21.6188 29.013 21.6188 28.8177 21.8141C28.6225 22.0093 28.6225 22.3259 28.8177 22.5212L31.6461 25.3496L28.8177 28.178C28.6225 28.3733 28.6225 28.6899 28.8177 28.8851C29.013 29.0804 29.3296 29.0804 29.5248 28.8851L32.7068 25.7032ZM0.0808105 25.3496L0.0808105 25.8496L32.3533 25.8496L32.3533 25.3496L32.3533 24.8496L0.0808106 24.8496L0.0808105 25.3496Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51234 16.5168H4.31454V13.3288L3.39478 13.8682V13.0867L4.61882 12.3398H5.1859V16.5168H5.98118V17.1807H3.51234V16.5168Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6094 16.5166C14.9229 16.2907 15.241 16.021 15.5638 15.7075C15.8911 15.394 16.1677 15.0575 16.3936 14.6979C16.6195 14.3382 16.7325 13.9971 16.7325 13.6744C16.7325 13.4577 16.6702 13.2871 16.5458 13.1626C16.4213 13.0335 16.253 12.969 16.0409 12.969C15.8242 12.969 15.6168 13.0266 15.4185 13.1419C15.2249 13.2525 15.0682 13.4023 14.9483 13.5914L14.478 13.0935C14.6348 12.8353 14.8515 12.6347 15.1281 12.4918C15.4047 12.3443 15.7113 12.2705 16.0479 12.2705C16.5365 12.2705 16.9192 12.3927 17.1958 12.637C17.4771 12.8814 17.6177 13.2179 17.6177 13.6467C17.6177 14.4258 17.0022 15.3825 15.7712 16.5166H17.7975V17.1805H14.6094V16.5166Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6152 17.2497C27.2648 17.2497 26.949 17.1828 26.6678 17.0491C26.3912 16.9154 26.1837 16.7333 26.0454 16.5028L26.4742 16.0187C26.6033 16.1755 26.7692 16.3023 26.9721 16.3991C27.1749 16.4959 27.3778 16.5443 27.5807 16.5443C27.8342 16.5443 28.0394 16.4728 28.1961 16.3299C28.3529 16.1824 28.4313 15.9934 28.4313 15.7628C28.4313 15.5093 28.3368 15.3133 28.1477 15.175C27.9587 15.0367 27.6982 14.9676 27.3663 14.9676H27.0067V14.3244H27.3594C27.6268 14.3244 27.8434 14.253 28.0094 14.11C28.18 13.9671 28.2653 13.7827 28.2653 13.5568C28.2653 13.3724 28.2031 13.2295 28.0786 13.128C27.9587 13.0266 27.7835 12.9759 27.553 12.9759C27.3409 12.9759 27.1404 13.022 26.9513 13.1142C26.7623 13.2018 26.601 13.3286 26.4673 13.4946L26.0592 13.0105C26.2206 12.78 26.4419 12.6001 26.7231 12.4711C27.009 12.3374 27.3202 12.2705 27.6567 12.2705C27.9518 12.2705 28.21 12.3212 28.4313 12.4226C28.6572 12.5195 28.8301 12.6578 28.9499 12.8376C29.0744 13.0174 29.1366 13.2272 29.1366 13.4669C29.1366 13.7205 29.0652 13.9464 28.9223 14.1446C28.7793 14.3429 28.5765 14.4973 28.3137 14.608C28.641 14.7094 28.8877 14.8615 29.0537 15.0644C29.2242 15.2672 29.3095 15.5185 29.3095 15.8182C29.3095 16.0994 29.2381 16.3484 29.0952 16.565C28.9568 16.7817 28.7586 16.95 28.5004 17.0699C28.2469 17.1898 27.9518 17.2497 27.6152 17.2497Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftAdvice3);
export default __webpack_public_path__ + "static/media/DraftAdvice3.82a181aff42bf33f5cecbb48d727033c.svg";
export { ForwardRef as ReactComponent };